import React from 'react';
// import PropTypes from 'prop-types';

import {Routes, Route, Navigate} from 'react-router';

import EventList from './event_list';
import Dashboard from './dashboard';
import CaregiverList from './caregiver/CaregiverList';
import CaregiverDetail from './caregiver/CaregiverDetail';
import Home from './home';
import EventFeedback from './feedback/EventFeedback';

import SignOut from './auth/Signout';
import ClientProfile from './profile/ClientProfile';
import ClientForm from './form/ClientForm';

const Router = () => {
  return (
    <Routes>
      <Route path="/" Component={Home} />
      <Route path="/dashboard" Component={Dashboard} />

      <Route path="/events" Component={EventList} />
      <Route path="/events/:eventRn" Component={EventList} />

      <Route path ="/caregivers" Component={CaregiverList} />
      <Route path="/caregivers/:caregiverRnOrShortId" Component={CaregiverDetail} />

      <Route path="/profile/client_profile" Component={ClientProfile} />

      <Route path="/form/client_form" Component={ClientForm} />

      <Route path="/feedback/event/:eventFeedbackRn" Component={EventFeedback} />

      <Route path="/signout" Component={SignOut} />
      <Route path="/magic-link" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

Router.propTypes = {
};

export default React.memo(Router);

